import { every } from 'lodash';
import { Component, ElementRef, OnInit, Input, ViewChild } from '@angular/core';
import { GridService } from '../../grid.service';
import { GridsterConfig } from 'angular-gridster2';

@Component({
  selector: 'app-content-panel-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.less']
})
export class ContentComponent implements OnInit {
  @ViewChild('panelDropdownButton') public panelDropdownButtonRef: ElementRef;
  thisElement = null;
  activeView = 'grid';
  isPanelDropdownShown = false;
  isLayoutDropdownShown = false;
  isRssEditModalShown = false;
  isTwitterEditModalShown = false;
  isWriteModalShown = false;
  isGoogleplusEditModalShown = false;
  isPinterestEditModalShown = false;
  isTumblrModalShown = false;
  isInstagramModalShown = false;
  isFlickrModalShown = false;
  isFlipbookModalShown = false;
  isSlideshareModalShown = false;
  isYoutubeModalShown = false;

  gridOptions: GridsterConfig = {
    draggable: {
      enabled: true,

      // Tricky way to prevent drop over panel grid
      start: (item) => {
        this.panelCardsBeforeDrop = this.gridService.panelCards.slice(0);
      },

      stop: (item, gridsterItem, event) => {
        // Do not allow moving a card across right panel grid.
        // Can't do this with grid options as it will restrict the possibility to move card downward the grid.
        if (!this.gridService.dropPanelCard(item, gridsterItem, event)) {
          this.gridService.setPanelCards(this.panelCardsBeforeDrop);
          this.gridOptions.api.optionsChanged();
        }

        this.setCurrentCountRowsToContent();
      },
    },

    minCols          : 2,
    minRows          : 2,
    maxCols          : 2,
    mobileBreakpoint : 0,
    gridType         : 'verticalFixed',
    fixedRowHeight   : 200,
    margin           : 20,
    displayGrid      : 'none',
    outerMargin      : false,
    swap             : false,
    disablePushOnDrag: true,
  };

  panelCardsBeforeDrop: Object[];

  constructor(
    public gridService: GridService,
    public element: ElementRef,
  ) {
    this.thisElement = element.nativeElement;
  }

  activateView(view: 'grid' | 'list') {
    this.activeView = view;
  }

  onPanelDropdownClick() {
    this.isPanelDropdownShown = !this.isPanelDropdownShown;
  }

  onLayoutDropdownClick() {
    this.isLayoutDropdownShown = !this.isLayoutDropdownShown;
  }

  setCurrentCountRowsToContent() {
    // Passing css variables through the attribute in this case does not work
    this.thisElement.style.setProperty('--rows', Math.ceil(this.gridService.panelCards.length / 2));
  }

  openRssEditModal() {
    this.isRssEditModalShown = true;
  }

  closeRssEditModal() {
    this.isRssEditModalShown = false;
  }

  openTwitterEditModal() {
    this.isTwitterEditModalShown = true;
  }

  closeTwitterEditModal() {
    this.isTwitterEditModalShown = false;
  }

  openWriteModal() {
    this.isWriteModalShown = true;
  }

  closeWriteModal() {
    this.isWriteModalShown = false;
  }

  openGoogleplusEditModal() {
    this.isGoogleplusEditModalShown = true;
  }

  closeGoogleplusEditModal() {
    this.isGoogleplusEditModalShown = false;
  }

  openPinterestEditModal() {
    this.isPinterestEditModalShown = true;
  }

  closePinterestEditModal() {
    this.isPinterestEditModalShown = false;
  }

  openTumblrModal() {
    this.isTumblrModalShown = true;
  }

  closeTumblrModal() {
    this.isTumblrModalShown = false;
  }

  openInstagramModal() {
    this.isInstagramModalShown = true;
  }

  closeInstagramModal() {
    this.isInstagramModalShown = false;
  }

  openFlickrModal() {
    this.isFlickrModalShown = true;
  }

  closeFlickrModal() {
    this.isFlickrModalShown = false;
  }

  openFlipbookModal() {
    this.isFlipbookModalShown = true;
  }

  closeFlipbookModal() {
    this.isFlipbookModalShown = false;
  }

  openSlideshareModal() {
    this.isSlideshareModalShown = true;
  }

  closeSlideshareModal() {
    this.isSlideshareModalShown = false;
  }

  openYoutubeModal() {
    this.isYoutubeModalShown = true;
  }

  closeYoutubeModal() {
    this.isYoutubeModalShown = false;
  }

  ngOnInit() {
    window.addEventListener('click', (event: MouseEvent & {path: Array<{}>}) => {
      if (every(event.path, node => this.panelDropdownButtonRef.nativeElement !== node)) {
        this.isPanelDropdownShown = false;
      }
    });

    this.setCurrentCountRowsToContent();
  }
}



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/edit/content-panel/content/content.component.ts